/**
 * Where the backend lives.
 *
 * Empty in development — `vite.config.ts` proxies `/api` to the FastAPI server
 * so everything is same-origin. In production this is the Cloudflare tunnel
 * origin injected at build time by Vercel.
 */
const RAW_BASE = import.meta.env.VITE_API_BASE_URL ?? ''

export const API_BASE = RAW_BASE.trim().replace(/\/+$/, '')

/** `apiUrl('/api/health')` → `https://api.example.com/api/health` */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`
}

/** Absolute URL of a finished job's MP3. */
export function jobFileUrl(jobId: string): string {
  return apiUrl(`/api/jobs/${encodeURIComponent(jobId)}/file`)
}

/** SSE endpoint for a job. */
export function jobEventsUrl(jobId: string): string {
  return apiUrl(`/api/jobs/${encodeURIComponent(jobId)}/events`)
}

/** `res.json()` that never throws — a proxy HTML page must not crash the app. */
export async function readJson(response: Response): Promise<unknown> {
  try {
    return (await response.json()) as unknown
  } catch {
    return null
  }
}
